export default __webpack_public_path__ + "static/media/100.bf88831f.jpg";